exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userListTable_2QH3J {\n    font-size: 12px;\n}\n\n.userListTable_2QH3J thead tr th {\n    text-align: center;\n    background-color: #e9f4ff;\n    font-size: 13px;\n    font-weight: 800;\n    text-transform: uppercase;\n    line-height: 1.5rem;\n    position: relative;\n    color: #939393;\n}\n\n.userListTable_2QH3J .empty_1W-jq {\n    text-align: center;\n}\n\n.userListTable_2QH3J tbody tr td {\n    cursor: pointer;\n    border: none !important;\n}\n\n.planTable_bNNJl {\n    margin-bottom: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"userListTable": "userListTable_2QH3J",
	"empty": "empty_1W-jq",
	"planTable": "planTable_bNNJl"
};